import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { FirstTimeSection } from './components/FirstTimeSection';
import { VisualSection } from './components/VisualSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  /** Page palette: dark navy "court" look or the light "chalk" look. Both use orange buttons. */
  theme?: 'court' | 'chalk';
}
const THEME_COLORS = {
  court: '#020617',
  chalk: '#f8fafc'
};
export function App({
  theme = 'court'
}: AppProps) {
  useMetaPixel();
  useEffect(() => {
    // The `chalk` class on <html> drives every `[.chalk_&]:` variant on the page.
    document.documentElement.classList.toggle('chalk', theme === 'chalk');
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme]);
  }, [theme]);
  return <div className="w-full bg-slate-950 font-sans text-slate-50 antialiased [.chalk_&]:bg-slate-50 [.chalk_&]:text-slate-900" data-id="element-0" data-mp="2zmwif0bo3qdb">
      <Hero data-id="element-1" data-mp="33oi0d0326uud" />
      <main data-id="element-2" data-mp="38m1elzzrb7mb">
        <TestimonialsSection data-id="element-3" data-mp="38l8f9k34nke7" />
        <ProblemSection data-id="element-4" data-mp="38k6u2msedhir" />
        <VolumesSection data-id="element-5" data-mp="38nulngea7tuu" />
        <BonusesSection data-id="element-6" data-mp="3dkl5met7j9lj" />
        <FirstTimeSection data-id="element-7" data-mp="3dlw6a5rcw18f" />
        <VisualSection data-id="element-8" data-mp="3dm5z013scmht" />
        <OfferSection data-id="element-9" data-mp="3dii694660445" />
        <GuaranteeSection data-id="element-10" data-mp="nw2a60hx7gog" />
        <FaqSection data-id="element-11" data-mp="nur762waucye" />
        <FinalCtaSection data-id="element-12" data-mp="nvas7sh8xhgn" />
      </main>
      <Footer data-id="element-13" data-mp="sudmchvou39u" />
      <StickyCta data-id="element-14" data-mp="stuejtzr4v9j" />
    </div>;
}